import React from 'react';

export function BrandImage(props) {
    return (
        <img
            alt={props.heading}
            className={'BrandingContent__logo'}
            src={props.logo}
        />
    );
}
